// VideoBlock.jsx
import React from "react";
import { Card, Skeleton } from "antd";
import tool from "@/assets/tool";
import { video_bq } from "@/assets/jfData";
const VideoBlock = (props) => {
  const sectionStyle = {
    backgroundImage: `url(${props.value?.cover})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    height: "25vh",
    width: "100%",
    padding: "10px",
    paddingTop: "30px",
    color: "#fff",
  };

  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.videoId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/video_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };

  const getLabel = (l) => {
    const bq = video_bq;
    const label = bq.find((v) => v.key === l)?.value;
    return label || "未知标签";
  };

  return (
    <Card onClick={() => toDetail(props.value)}>
      {props.value ? (
        <>
          <div
            style={sectionStyle}
            className={`vispage_back_size ${props.value.cover ? "" : "noBac"}`}
          >
            <div className="title child webTitle cyber-text">
              {props.value.title}
            </div>
          </div>
          <div className="child video-name">
            <div>
              <img
                src={`/file/${props.value.profilePictureUrl}`}
                alt={""}
                className="tx"
              />
              <span>
                {props.value.nickName || tool.hideMiddleFour(props.value.phone)}
              </span>
            </div>
            <span>{props.value.createTime}</span>
          </div>
          <div className="child">{getLabel(props.value.label)}</div>
        </>
      ) : (
        <Skeleton active paragraph={{ rows: 4 }} />
      )}
    </Card>
  );
};

export default VideoBlock;
